export const queueRoute = '/apartment/queue';
